import axios from 'axios'
import { AllCompanies } from '../features/bedManagement/endpoints/EndPoints'
import KeycloakService from '../utils/keycloakService'
import { lmsIntent, sucessErrorMsg } from './constants'
import { startSxpProxy } from '../utils/api'
import { ADMIN_PROJECT_ID } from '../utils/constants'

export const GetAllCompanies = async () => {
  const token = KeycloakService?.getToken()
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_API_GATEWAY_URL}${AllCompanies}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
      }
    )
    return {
      data: response?.data?.company,
      success: true,
      message: sucessErrorMsg?.companySucessMsg,
    }
  } catch {
    return {
      data: null,
      success: false,
      message: sucessErrorMsg?.companyErrorMsg,
    }
  }
}
export const getAllPriceList = async (): Promise<any[]> => {
  try {
    const state = {}
    const data = await startSxpProxy(
      ADMIN_PROJECT_ID,
      lmsIntent?.getAllPriceList,
      state
    )
    const pricelist: any[] = Array?.isArray(data?.data)
      ? data?.data
      : Array?.isArray(data)
      ? data
      : []
    return pricelist
  } catch (error) {
    console.error(error)
    return []
  }
}
